__turbopack_context__.v({
  "className": "Qpm9pG_className",
  "variable": "Qpm9pG_variable",
});
